module.exports = __webpack_public_path__ + "img/Paymen-Completed-dashboard-en.512370a.png";